var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContentDiv',[_c('PageTitle',[_vm._v("Settings")]),_c('p',[_vm._v(" Configure various settings relating to your Organisation(s) and Team Members ")]),_c('PageTitleDivider'),(
        _vm.organisationStore.companyID === 'undefined' ||
        _vm.organisationStore.companyID == null)?[_c('PageSubtitle',{staticClass:"my-5"},[_vm._v("Create an organisation")]),_c('OrganisationGeneral',{staticClass:"my-10"})]:_c('OrganisationSettings',{staticClass:"my-10"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }